import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import axiosApi from "./../servicios/axios.service";
import { peticionGet } from "Componentes/ComponenteAxios";
import SedeContent from "./SedeContent"; // Importa el componente SedeContent
const { DateTime } = require("luxon");
const SedesTabs = () => {
  const [sedes, setSedes] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [ultimactualizacion, setultimaactualizacion] = useState(DateTime.now());

  useEffect(() => {
    // Aquí realizamos la consulta a la API para obtener las sedes

    const fetchSedes = async () => {
      peticionGet("/panel/listadosedes").then(({ peticion, error, status }) => {
        if (error) {
          // migaPanRef.current?.mostrarSnack({
          //   mensaje:
          //     peticion?.mensajeSnack || "No se han podido recuperar los datos",
          //   tipo: peticion?.tipoSnack || "error",
          // });
        } else {
          console.log(peticion);
          setSedes(peticion || {});
        }
      });
    };

    fetchSedes();

    // Crear un intervalo para llamar a fetchSedes cada 10 minutos (600000 ms)
    const intervalId = setInterval(fetchSedes, 600000);

    // Limpiar el intervalo cuando el componente se desmonte
    return () => clearInterval(intervalId);
  }, []);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={selectedTab}
        onChange={handleChange}
        aria-label="tabs de sedes"
      >
        {sedes.map((sede, index) => (
          <Tab key={sede.id} label={sede.localidad} />
        ))}
      </Tabs>
      <Box sx={{ p: 3 }}>
        {sedes.map((sede, index) => (
          <div
            role="tabpanel"
            hidden={selectedTab !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            key={sede.id}
          >
            {selectedTab === index && (
              <SedeContent
                ultimactualizacion={ultimactualizacion}
                sedeId={sede.id}
                sedes={sedes}
              /> /* Renderiza el componente SedeContent */
            )}
          </div>
        ))}
      </Box>
    </Box>
  );
};

export default SedesTabs;
